export const voiceVlanConfig = {
  voiceVlanOption: 'DISABLE',
  voiceVlanId: 2,
  voiceVlanCosList: [
    {
      label: '0',
      value: 0,
      isActive: false,
    },
    {
      label: '1',
      value: 1,
      isActive: false,
    },
    {
      label: '2',
      value: 2,
      isActive: false,
    },
    {
      label: '3',
      value: 3,
      isActive: false,
    },
    {
      label: '4',
      value: 4,
      isActive: false,
    },
    {
      label: '5',
      value: 5,
      isActive: true,
    },
    {
      label: '6',
      value: 6,
      isActive: false,
    },
    {
      label: '7',
      value: 7,
      isActive: false,
    },
  ],
  ouiBindingList: [],
  addOuiList: [
    {
      id: 0,
      address: '',
      mask: '',
      description: '',
      checked: false,
    },
  ],
};

export const MAX_OUI_BINDING_ENTRIES = 10;

export const predefinedOuiList = [
  { checked: false, address: '00:1A:2B:00:00:00', mask: 'FF:FF:FF:00:00:00', description: 'Enterprise Switch Vendor' },
  { checked: false, address: '14:5A:FC:10:00:00', mask: 'FF:FF:FF:F0:00:00', description: '' },
  { checked: false, address: '28:CF:DA:34:00:00', mask: 'FF:FF:FF:FF:00:00', description: 'VoIP Phone Model Range' },
  { checked: false, address: '3C:97:0E:12:40:00', mask: 'FF:FF:FF:FF:F0:00', description: 'Network Camera Sub-model' },
  { checked: false, address: '50:EB:71:89:AB:00', mask: 'FF:FF:FF:FF:FF:00', description: '' },
  { checked: false, address: '64:16:66:22:33:44', mask: 'FF:FF:FF:FF:FF:FF', description: 'Specific Device (Exact Match)' },
  { checked: false, address: '78:4F:43:90:00:00', mask: 'FF:FF:FF:FF:00:00', description: 'Office Endpoint Series' },
  { checked: false, address: '8C:85:90:AA:B0:00', mask: 'FF:FF:FF:FF:F0:00', description: 'Industrial Controller Line' },
  { checked: false, address: 'A4:5E:60:01:02:00', mask: 'FF:FF:FF:FF:FF:00', description: '' },
  { checked: false, address: 'D0:37:45:7C:8D:9E', mask: 'FF:FF:FF:FF:FF:FF', description: 'Access Control Unit (Single Device)' },
];
